import {
  BATCHED_SAMPLES,
  DISPATCHED_SAMPLES,
  DISPATCH_STEP,
  FETCH_COURIER_PROVIDER,
  FETCH_COURIER_PROVIDERS,
  LAB_NETWORK_LIST,
  MANIFEST_DATA,
} from "constants/ActionTypes";

const INITIAL_STATE = {
  courierProviders: [],
  courierProvider: {},
  loading: false,
  labNetworksList: [],
  batchedSamples: [],
  dispatchStep: 0,
  manifestData: [],
  dispatchedSamples: [],
};

const DispatchReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COURIER_PROVIDERS: {
      return {
        ...state,
        courierProviders: action.payload,
      };
    }
    case FETCH_COURIER_PROVIDER: {
      return {
        ...state,
        courierProvider: action.payload,
      };
    }
    case LAB_NETWORK_LIST: {
      return {
        ...state,
        labNetworksList: action.payload,
      };
    }
    case BATCHED_SAMPLES: {
      return {
        ...state,
        batchedSamples: action.payload,
      };
    }

    case DISPATCH_STEP: {
      return {
        ...state,
        dispatchStep: action.payload,
      };
    }

    case MANIFEST_DATA: {
      return {
        ...state,
        manifestData: action.payload,
      };
    }

    case DISPATCHED_SAMPLES: {
      return {
        ...state,
        dispatchedSamples: action.payload,
      };
    }

    default:
      return state;
  }
};

export default DispatchReducer;
